import {
  Companion_getInstance3m865vivtv009 as Companion_getInstance,
  HealthStatusyf3nmc52arsb as HealthStatus,
  Level3nkvlyj1o3kmm as Level,
} from './HealthStatus.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareHealthStatusFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [HealthStatus_level_getInstance(), HealthStatus_checkedAt_getInstance(), HealthStatus_additionalMessage_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function HealthStatus_level$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function HealthStatus_level$_get_name_$ref_lz6ybk() {
  return (p0) => p0.i20();
}
function HealthStatus_level$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function HealthStatus_level$_get_serializer_$ref_8e8xrb() {
  return (p0) => p0.h2j();
}
function HealthStatus_level$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function HealthStatus_level$_get_annotations_$ref_7r22vf() {
  return (p0) => p0.bz();
}
var HealthStatus_levelClass;
function HealthStatus_level() {
  if (HealthStatus_levelClass === VOID) {
    class $ {
      constructor() {
        HealthStatus_level_instance = this;
        var tmp = this;
        tmp.p3e_1 = lazy(HealthStatus_level$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q3e_1 = lazy(HealthStatus_level$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r3e_1 = lazy(HealthStatus_level$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.p3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, HealthStatus_level$_get_name_$ref_lz6ybk(), null);
        return tmp0.f2();
      }
      s3e(receiver) {
        return receiver.t3e_1;
      }
      k2j(receiver) {
        return this.s3e(receiver instanceof HealthStatus() ? receiver : THROW_CCE());
      }
      w3e(receiver, value) {
        return receiver.x3e(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof HealthStatus() ? receiver : THROW_CCE();
        return this.w3e(tmp, value instanceof Level() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, HealthStatus_level$_get_serializer_$ref_8e8xrb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, HealthStatus_level$_get_annotations_$ref_7r22vf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'HealthStatus_level', VOID, VOID, [SerializableProperty()]);
    HealthStatus_levelClass = $;
  }
  return HealthStatus_levelClass;
}
var HealthStatus_level_instance;
function HealthStatus_level_getInstance() {
  if (HealthStatus_level_instance === VOID)
    new (HealthStatus_level())();
  return HealthStatus_level_instance;
}
function HealthStatus_checkedAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function HealthStatus_checkedAt$_get_name_$ref_ncoud2() {
  return (p0) => p0.i20();
}
function HealthStatus_checkedAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function HealthStatus_checkedAt$_get_serializer_$ref_v21foj() {
  return (p0) => p0.h2j();
}
function HealthStatus_checkedAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function HealthStatus_checkedAt$_get_annotations_$ref_n92pxd() {
  return (p0) => p0.bz();
}
var HealthStatus_checkedAtClass;
function HealthStatus_checkedAt() {
  if (HealthStatus_checkedAtClass === VOID) {
    class $ {
      constructor() {
        HealthStatus_checkedAt_instance = this;
        var tmp = this;
        tmp.y3e_1 = lazy(HealthStatus_checkedAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z3e_1 = lazy(HealthStatus_checkedAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a3f_1 = lazy(HealthStatus_checkedAt$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.b3f_1 = get_default(Companion_instance).b1m();
        this.c3f_1 = 'now()';
      }
      i20() {
        var tmp0 = this.y3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, HealthStatus_checkedAt$_get_name_$ref_ncoud2(), null);
        return tmp0.f2();
      }
      s3e(receiver) {
        return receiver.u3e_1;
      }
      k2j(receiver) {
        return this.s3e(receiver instanceof HealthStatus() ? receiver : THROW_CCE());
      }
      d3f(receiver, value) {
        return receiver.x3e(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof HealthStatus() ? receiver : THROW_CCE();
        return this.d3f(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z3e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, HealthStatus_checkedAt$_get_serializer_$ref_v21foj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, HealthStatus_checkedAt$_get_annotations_$ref_n92pxd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'HealthStatus_checkedAt', VOID, VOID, [SerializableProperty()]);
    HealthStatus_checkedAtClass = $;
  }
  return HealthStatus_checkedAtClass;
}
var HealthStatus_checkedAt_instance;
function HealthStatus_checkedAt_getInstance() {
  if (HealthStatus_checkedAt_instance === VOID)
    new (HealthStatus_checkedAt())();
  return HealthStatus_checkedAt_instance;
}
function HealthStatus_additionalMessage$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function HealthStatus_additionalMessage$_get_name_$ref_7ezdus() {
  return (p0) => p0.i20();
}
function HealthStatus_additionalMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function HealthStatus_additionalMessage$_get_serializer_$ref_ylnikd() {
  return (p0) => p0.h2j();
}
function HealthStatus_additionalMessage$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function HealthStatus_additionalMessage$_get_annotations_$ref_8x4wm1() {
  return (p0) => p0.bz();
}
var HealthStatus_additionalMessageClass;
function HealthStatus_additionalMessage() {
  if (HealthStatus_additionalMessageClass === VOID) {
    class $ {
      constructor() {
        HealthStatus_additionalMessage_instance = this;
        var tmp = this;
        tmp.e3f_1 = lazy(HealthStatus_additionalMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f3f_1 = lazy(HealthStatus_additionalMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g3f_1 = lazy(HealthStatus_additionalMessage$annotations$delegate$lambda);
        this.h3f_1 = null;
        this.i3f_1 = 'null';
      }
      i20() {
        var tmp0 = this.e3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, HealthStatus_additionalMessage$_get_name_$ref_7ezdus(), null);
        return tmp0.f2();
      }
      s3e(receiver) {
        return receiver.v3e_1;
      }
      k2j(receiver) {
        return this.s3e(receiver instanceof HealthStatus() ? receiver : THROW_CCE());
      }
      j3f(receiver, value) {
        return receiver.x3e(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof HealthStatus() ? receiver : THROW_CCE();
        return this.j3f(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, HealthStatus_additionalMessage$_get_serializer_$ref_ylnikd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g3f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, HealthStatus_additionalMessage$_get_annotations_$ref_8x4wm1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'HealthStatus_additionalMessage', VOID, VOID, [SerializableProperty()]);
    HealthStatus_additionalMessageClass = $;
  }
  return HealthStatus_additionalMessageClass;
}
var HealthStatus_additionalMessage_instance;
function HealthStatus_additionalMessage_getInstance() {
  if (HealthStatus_additionalMessage_instance === VOID)
    new (HealthStatus_additionalMessage())();
  return HealthStatus_additionalMessage_instance;
}
//region block: exports
export {
  prepareHealthStatusFields as prepareHealthStatusFields3rwycni69473l,
};
//endregion

//# sourceMappingURL=HealthStatusFields.mjs.map
